import { Phone, MessageCircle } from "lucide-react";

export const FloatingActions = ({ content = {} }) => {
  const wa = content.whatsapp || "919000000000";
  const phone = content.phone || "+91 90000 00000";
  return (
    <div className="fixed z-40 bottom-5 right-5 flex flex-col gap-3">
      <a
        href={`https://wa.me/${wa}?text=${encodeURIComponent("Hi WEDDING EVENTS, I'd like to plan an event.")}`}
        target="_blank" rel="noreferrer"
        data-testid="whatsapp-float-btn"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 grid place-items-center rounded-full bg-[#25D366] text-white shadow-lg animate-pulse-ring hover:scale-105 transition-transform"
      >
        <MessageCircle size={26} />
      </a>
      <a
        href={`tel:${phone.replace(/\s/g, "")}`}
        data-testid="call-float-btn"
        aria-label="Call us"
        className="w-14 h-14 grid place-items-center rounded-full bg-brand-gold text-brand-navy shadow-lg hover:scale-105 transition-transform sm:hidden"
      >
        <Phone size={24} />
      </a>
    </div>
  );
};
